module.exports = __webpack_public_path__ + "img/37_76.06e3d87f.png";